// src/components/learning/ArabicLetterCard.js
import React, { useState } from 'react';
import { playArabic } from '../../utils/audioPlayer';  // ← AJOUTER CETTE LIGNE

const ArabicLetterCard = ({ letter, onNext, onPrevious, currentIndex, totalLetters }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [activeForm, setActiveForm] = useState('isolated');
  const [showExamples, setShowExamples] = useState(false);

const playAudio = (text) => {
  setIsPlaying(true);
  playArabic(text);
  // Reset après 2 secondes (durée approximative de l'audio)
  setTimeout(() => setIsPlaying(false), 2000);
};

  const forms = [
    { key: 'isolated', label: 'Isolée', desc: 'Seule' },
    { key: 'initial', label: 'Initiale', desc: 'Début' },
    { key: 'medial', label: 'Médiane', desc: 'Milieu' },
    { key: 'final', label: 'Finale', desc: 'Fin' }
  ];

  return (
    <div style={{
      background: `linear-gradient(135deg, ${letter.color}dd 0%, ${letter.color}99 100%)`,
      borderRadius: '20px',
      padding: '1.5rem',
      color: 'white',
      maxWidth: '500px',
      margin: '0 auto',
      boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
    }}>
      {/* Header avec navigation */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem'
      }}>
        <button
          onClick={onPrevious}
          disabled={currentIndex === 0}
          style={{
            background: currentIndex === 0 ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.3)',
            border: 'none',
            borderRadius: '50%',
            width: '44px',
            height: '44px',
            color: 'white',
            fontSize: '1.4rem',
            cursor: currentIndex === 0 ? 'not-allowed' : 'pointer',
            transition: 'all 0.3s',
            opacity: currentIndex === 0 ? 0.5 : 1
          }}
        >
          ←
        </button>
        
        <div style={{ textAlign: 'center' }}>
          <span style={{ 
            fontSize: '0.85rem', 
            opacity: 0.9,
            background: 'rgba(255,255,255,0.2)',
            padding: '0.3rem 0.8rem',
            borderRadius: '20px'
          }}>
            {currentIndex + 1} / {totalLetters}
          </span>
        </div>
        
        <button
          onClick={onNext}
          disabled={currentIndex === totalLetters - 1}
          style={{
            background: currentIndex === totalLetters - 1 ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.3)',
            border: 'none',
            borderRadius: '50%',
            width: '44px',
            height: '44px',
            color: 'white',
            fontSize: '1.4rem',
            cursor: currentIndex === totalLetters - 1 ? 'not-allowed' : 'pointer',
            transition: 'all 0.3s',
            opacity: currentIndex === totalLetters - 1 ? 0.5 : 1
          }}
        >
          →
        </button>
      </div>

      {/* Lettre principale */}
      <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
        <div 
          onClick={() => playAudio(letter.letter)}
          style={{
            fontSize: '7rem',
            fontFamily: "'Amiri', 'Traditional Arabic', serif",
            lineHeight: 1,
            cursor: 'pointer',
            transition: 'transform 0.3s',
            transform: isPlaying ? 'scale(1.1)' : 'scale(1)',
            textShadow: '0 4px 20px rgba(0,0,0,0.3)',
            userSelect: 'none'
          }}
        >
          {letter.forms[activeForm]}
        </div>
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.75rem',
          marginTop: '0.5rem'
        }}>
          <span style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>
            {letter.name}
          </span>
          <span style={{ fontSize: '1.1rem', opacity: 0.8 }}>
            ({letter.nameAr})
          </span>
          <button
            onClick={() => playAudio(letter.letter)}
            style={{
              background: isPlaying ? '#4CAF50' : 'rgba(255,255,255,0.25)',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              color: 'white',
              fontSize: '1.1rem',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}
          >
            {isPlaying ? '🔊' : '🔈'}
          </button>
        </div>
        
        <div style={{ marginTop: '0.5rem', fontSize: '1rem', opacity: 0.9 }}>
          <strong>Translittération :</strong> {letter.transliteration}
        </div>
        
        <div style={{
          marginTop: '0.25rem',
          fontSize: '0.9rem',
          opacity: 0.8,
          fontStyle: 'italic'
        }}>
          {letter.pronunciation}
        </div>
      </div>

      {/* Formes de la lettre */}
      <div style={{
        background: 'rgba(255,255,255,0.1)',
        borderRadius: '12px',
        padding: '1rem',
        marginBottom: '1rem'
      }}>
        <h4 style={{ margin: '0 0 0.75rem 0', fontSize: '0.9rem', opacity: 0.9 }}>
          ✏️ Les 4 formes de la lettre
        </h4>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '0.5rem'
        }}>
          {forms.map(form => (
            <button
              key={form.key}
              onClick={() => setActiveForm(form.key)}
              style={{
                background: activeForm === form.key ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.1)',
                border: activeForm === form.key ? '2px solid white' : '2px solid transparent',
                borderRadius: '10px',
                padding: '0.5rem 0.25rem',
                color: 'white',
                cursor: 'pointer',
                transition: 'all 0.3s'
              }}
            >
              <div style={{
                fontSize: '1.8rem',
                fontFamily: "'Amiri', 'Traditional Arabic', serif",
                lineHeight: 1.2
              }}>
                {letter.forms[form.key]}
              </div>
              <div style={{ fontSize: '0.65rem', marginTop: '0.25rem', fontWeight: '600' }}>
                {form.label}
              </div>
              <div style={{ fontSize: '0.55rem', opacity: 0.7 }}>
                {form.desc}
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Notes */}
      {letter.notes && (
        <div style={{
          background: 'rgba(255,255,255,0.1)',
          borderRadius: '8px',
          padding: '0.75rem',
          marginBottom: '1rem',
          fontSize: '0.85rem'
        }}>
          💡 <strong>Note :</strong> {letter.notes}
        </div>
      )}

      {/* Exemples */}
      <div>
        <button
          onClick={() => setShowExamples(!showExamples)}
          style={{
            width: '100%',
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            borderRadius: '8px',
            padding: '0.75rem',
            color: 'white',
            fontSize: '0.9rem',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: '600'
          }}
        >
          <span>📚 Exemples de mots ({letter.examples.length})</span>
          <span style={{ 
            transform: showExamples ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s'
          }}>▼</span>
        </button>
        
        {showExamples && (
          <div style={{
            marginTop: '0.75rem',
            display: 'grid',
            gap: '0.5rem'
          }}>
            {letter.examples.map((example, idx) => (
              <div
                key={idx}
                onClick={() => playAudio(example.word)}
                style={{
                  background: 'rgba(255,255,255,0.15)',
                  borderRadius: '10px',
                  padding: '0.75rem 1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                  transition: 'background 0.3s'
                }}
              >
                <div>
                  <div style={{
                    fontSize: '1.6rem',
                    fontFamily: "'Amiri', 'Traditional Arabic', serif"
                  }}>
                    {example.word}
                  </div>
                  <div style={{ fontSize: '0.8rem', opacity: 0.85, marginTop: '0.2rem' }}>
                    <span style={{ fontWeight: '600' }}>{example.transliteration}</span>
                    {' = '}
                    <span>{example.meaning}</span>
                  </div>
                </div>
                <span style={{ fontSize: '1.3rem', opacity: 0.8 }}>🔊</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ArabicLetterCard;
